import { createContext, useContext } from 'react';

import { type FormValues } from '../ui/form/types';

export const FormValuesContext = createContext<FormValues | undefined>(
  undefined,
);

export function useFormValues(): FormValues {
  const context = useContext(FormValuesContext);
  if (context === undefined) {
    throw new Error('useFormValues must be used within a FormValuesProvider');
  }

  return context;
}
